export default __webpack_public_path__ + "static/media/casino-chips-ico-black.4823715d.svg";